import { api } from "@/services"
import type { Setlist } from "@/services/api"
import { createStoreState, createParamStoreState } from "."

export const useActiveSetlistStore = defineStore("activeSetlist", {
  state: () => {
    return {
      setlist: null as Setlist | null,
      open: true,
    }
  },
})

export const useSetlistlistStore = defineStore(
  "setlistlist",
  createStoreState(async () => await api.setlists.listSetlists()),
)

export const useSetlistStore = defineStore(
  "setlist",
  createParamStoreState(
    async (params: { setlistId: string }) =>
      await api.setlists.getSetlist(params.setlistId),
  ),
)

export const useSetlistPositionlistStore = defineStore(
  "setlistpositionlist",
  createParamStoreState(
    async (params: { setlistId: string }) =>
      await api.setlists.listSetlistPositions(params.setlistId),
  ),
)

export const useSetlistPositionStore = defineStore(
  "setlistposition",
  createParamStoreState(
    async (params: { setlistId: string; positionId: string }) =>
      await api.setlists.getSetlistPosition(params.setlistId, params.positionId),
  ),
)

export const useSetlistSheetStore = defineStore(
  "setlistsheet",
  createParamStoreState(
    async (params: { setlistId: string; sheetId: string }) =>
      await api.setlists.getSetlistSheet(params.setlistId, params.sheetId),
  ),
)

export const useSetlistSheetlistStore = defineStore(
  "setlistsheetlist",
  createParamStoreState(
    async (params: { setlistId: string }) =>
      await api.setlists.listSetlistSheets(params.setlistId),
  ),
)

export const useSetlistRecordinglistStore = defineStore(
  "setlistrecordinglist",
  createParamStoreState(
    async (params: { setlistId: string }) =>
      await api.setlists.listSetlistRecordings(params.setlistId),
  ),
)

export const useSetlistRecordingStore = defineStore(
  "setlistrecording",
  createParamStoreState(
    async (params: { setlistId: string; recordingId: string }) =>
      await api.setlists.getSetlistRecording(params.setlistId, params.recordingId),
  ),
)

export const useSetlistRecordingMarklistStore = defineStore(
  "setlistrecordingmarklist",
  createParamStoreState(
    async (params: { setlistId: string; recordingId: string }) =>
      await api.setlists.listSetlistRecordingMarks(
        params.setlistId,
        params.recordingId,
      ),
  ),
)

export const useSetlistInfoLatestStore = defineStore(
  "setlistinfolatest",
  createStoreState(async () => await api.setlists.getSetlistInfo("LATEST")),
)

export const useSetlistRefreshStore = defineStore(
  "setlistRefresh",
  createRefreshStoreState([
    useSetlistlistStore,
    useSetlistStore,
    useSetlistPositionlistStore,
    useSetlistPositionStore,
    useSetlistSheetlistStore,
    useSetlistRecordinglistStore,
    useSetlistRecordingStore,
    useSetlistRecordingMarklistStore,
    useSetlistInfoLatestStore,
  ]),
)
